<template>
    <div class="b_brochure" :class="[excludeFromPrintClassName]">
        <div class="brochure_form box_shadow br20">
            <div class="form_block flex flex_center justify_center">
                <div class="image_wrap">
                    <div class="image">
                        <picture v-full-image-path:assets="'icon_pdf.svg'" />
                    </div>
                </div>

                <div class="info_wrap">
                    <div class="title">
                        <h3>{{ value.title }}</h3>
                    </div>

                    <div class="form">
                        <form @submit.prevent="onSubmit">
                            <div class="form_inner flex flex_center">
                                <input
                                    v-model="email"
                                    class="form_control"
                                    :class="{
                                        'is-invalid': error
                                    }"
                                    type="email"
                                    :placeholder="
                                        $t(
                                            'contentBuilder.emailMe.emailPlaceholder'
                                        )
                                    "
                                    @input="error = false"
                                />

                                <input
                                    class="btn btn_gray"
                                    type="submit"
                                    :value="$t('contentBuilder.emailMe.submit')"
                                />
                            </div>

                            <div class="agree">
                                <label class="label_checkbox">
                                    <input
                                        v-model="newsletter"
                                        type="checkbox"
                                    />

                                    <span class="checkbox_title">
                                        {{
                                            $t(
                                                'contentBuilder.emailMe.newsletter'
                                            )
                                        }}
                                    </span>
                                </label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: true
        },

        excludeFromPrintClassName: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            error: false,
            email: null,
            newsletter: false
        };
    },

    methods: {
        ...mapActions({
            emailMe: 'articles/emailMe'
        }),

        async onSubmit() {
            if (!this.email) {
                this.error = true;
            }

            try {
                await this.emailMe({
                    id: this.$route.params.slug,
                    email: this.email,
                    newsletter: this.newsletter
                });

                this.email = null;

                this.$toasted.success(this.$t('articles.sendFile.success'));
            } catch (error) {
                this.$toasted.global.error(this.$t('articles.sendFile.error'));
            }
        }
    }
};
</script>
